/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Share_Video_EncodingInputs */

const en_us2_share_video_encoding = /** @type {(inputs: Share_Video_EncodingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Making the video… ${i?.pct}%`)
};

const pt_br2_share_video_encoding = /** @type {(inputs: Share_Video_EncodingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gerando o vídeo… ${i?.pct}%`)
};

const es_419_share_video_encoding = /** @type {(inputs: Share_Video_EncodingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generando el video… ${i?.pct}%`)
};

const pt_pt2_share_video_encoding = /** @type {(inputs: Share_Video_EncodingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A gerar o vídeo… ${i?.pct}%`)
};

const fr_fr2_share_video_encoding = /** @type {(inputs: Share_Video_EncodingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Création de la vidéo… ${i?.pct} %`)
};

const de_de2_share_video_encoding = /** @type {(inputs: Share_Video_EncodingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Video wird erstellt… ${i?.pct}%`)
};

const it_it2_share_video_encoding = /** @type {(inputs: Share_Video_EncodingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Creazione del video… ${i?.pct}%`)
};

/**
* | output |
* | --- |
* | "Making the video… {pct}%" |
*
* @param {Share_Video_EncodingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_video_encoding = /** @type {((inputs: Share_Video_EncodingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Video_EncodingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_video_encoding(inputs)
	if (locale === "es-419") return es_419_share_video_encoding(inputs)
	if (locale === "pt-PT") return pt_pt2_share_video_encoding(inputs)
	if (locale === "fr-FR") return fr_fr2_share_video_encoding(inputs)
	if (locale === "de-DE") return de_de2_share_video_encoding(inputs)
	if (locale === "it-IT") return it_it2_share_video_encoding(inputs)
	return en_us2_share_video_encoding(inputs)
});
export { share_video_encoding as "share.video_encoding" }